// src/message-rules/messageAutomationsApi.ts
import { apiClient } from "@maat/api-base";
var messageAutomationsApi = {
  /**
   * The catalog joined with what this listing already has switched on.
   *
   * `listingId` is omitted by the create wizard: no listing exists yet, so every
   * row comes back with `applied: null` and nothing can be toggled.
   */
  listQuickActions: async (listingId) => {
    return apiClient.get("/chat/api/message-automations", {
      params: listingId ? { listing_id: listingId } : void 0
    });
  },
  /**
   * Switch an automation on, or move an already-applied one to a new body.
   *
   * Idempotent server-side under an advisory lock: re-applying updates the same
   * rule rather than creating a second one, so a host editing their copy never
   * ends up with a guest receiving two welcomes.
   */
  applyQuickAction: async (templateKey, data) => {
    return apiClient.post(`/chat/api/message-automations/${templateKey}/apply`, data);
  },
  /**
   * Switch an automation off for one listing. The underlying rule is deleted once
   * no listing still points at it.
   */
  removeQuickAction: async (templateKey, listingId) => {
    return apiClient.delete(`/chat/api/message-automations/${templateKey}`, {
      params: { listing_id: listingId }
    });
  }
};

export {
  messageAutomationsApi
};
